import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    init() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`/backup/init`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    process(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`/backup`, obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    download(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                axios({
                    url: `/backup/download/${obj.filename}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', obj.filename);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post(`/backup/remove`,obj);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
};